import React from "react";
import { Frame, TailObj } from "./styles";

export interface Props {
	direction: "fromTop" | "fromBottom" | "fromRight" | "fromLeft";
}
const Tail: React.FC<Props> = (props) => {
	const { direction } = props;
	return (
		<Frame direction={direction}>
			<TailObj width="18" height="16" direction={direction} forSm>
				<path
					d="M 0 0 L 5 0 L 18 8 L 5 16 L 0 16 L 0 13.5 L 9 8 L 0 2.5 Z"
					fill="rgb(26, 48, 128)"
				></path>
			</TailObj>
			<TailObj width="30" height="30" direction={direction}>
				<path
					d="M 27.2 30 L 14.8 9.7 L 2.8 30 L 0 30 L 0 25 L 14.7 0 L 30 25 L 30 30 Z"
					transform="rotate(90 15 15)"
					fill="rgb(26,48,129)"
				/>
			</TailObj>
		</Frame>
	);
};

export default Tail;
